// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"6a02b88a","117":"d54c0858","188":"1a274ae7","243":"36ab128d","632":"8b51ae65","808":"c0f53ef0"}[chunkId] + ".chunk.css";
};